import { useEffect, useState } from "react";
import { baseUrl } from "../../../shared/config";
import { useInfiniteStudentContacts } from "../api/getStudentContacts.js";

import {
  Avatar,
  Box,
  IconButton,
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  ListItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useInView } from "react-intersection-observer";

import { useNavigate } from "react-router-dom";
import ExpandableText from "./ExpandableText.jsx";
import {
  Favorite,
  FavoriteOutlined,
  Star,
  StarBorder,
} from "@mui/icons-material";
import _cookies from "../../../shared/utils/_cookies.js";
import AddUserToCloseFriends from "./AddUserToCloseFriends.jsx";

const StudentContacts = ({ studentId }) => {
  const [filter, setFilter] = useState();
  const [groupsFilter, setGroupsFilter] = useState();
  const [closeFriendsFilter, setCloseFriendsFilter] = useState(false);
  const contactsQuery = useInfiniteStudentContacts({
    studentId,
    filter,
    groupsFilter,
    closeFriendsFilter,
  });
  const bottomEl = useInView();

  const handleBottomEntersView = () => {
    if (contactsQuery.hasNextPage && !contactsQuery.isFetchingNextPage) {
      contactsQuery.fetchNextPage();
    }
  };
  useEffect(() => {
    if (bottomEl?.inView) {
      handleBottomEntersView();
    }
  }, [bottomEl?.inView]);

  const navigate = useNavigate();

  const handleClickContact = (contact) => () => {
    navigate("../social/perfil/" + (contact.alunoid || 1));
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const handleGroupsFilterChange = (event) => {
    setGroupsFilter(event.target.value);
  };

  const toggleCloseFriendsFilter = () => {
    setCloseFriendsFilter((prev) => !prev);
  };

  const displayCloseFriendsData = () => {
    return studentId == _cookies.getItem("auth").user.alunoid;
  };
  return (
    <Stack sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", gap: 1 }}>
        {displayCloseFriendsData() && (
          <IconButton onClick={toggleCloseFriendsFilter}>
            {closeFriendsFilter ? (
              <Star color="success" />
            ) : (
              <StarBorder color="success" />
            )}
          </IconButton>
        )}
        <TextField
          variant="standard"
          placeholder="Procurar contatos"
          value={filter}
          onChange={handleFilterChange}
          sx={{ width: "100%" }}
        />
        <TextField
          variant="standard"
          placeholder="Filtrar por grupos"
          value={groupsFilter}
          onChange={handleGroupsFilterChange}
          sx={{ width: "100%" }}
        />
      </Box>
      <List>
        {contactsQuery.data?.pages?.map((page) => {
          return page.map((contact) => {
            return (
              <ListItem
                secondaryAction={
                  displayCloseFriendsData() ? (
                    <AddUserToCloseFriends
                      studentId={contact.alunoid}
                      added={contact.favorito == "S"}
                    >
                      {({ mutate }) => {
                        return (
                          <IconButton color="success" onClick={mutate}>
                            {contact.favorito == "S" ? (
                              <Star />
                            ) : (
                              <StarBorder />
                            )}
                          </IconButton>
                        );
                      }}
                    </AddUserToCloseFriends>
                  ) : (
                    <></>
                  )
                }
              >
                <ListItemAvatar>
                  <Avatar
                    src={`${baseUrl}/membros/fotos/${contact?.fotoAluno}`}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography onClick={handleClickContact(contact)}>
                      {contact.nomeAluno}
                    </Typography>
                  }
                  secondary={<ExpandableText value={contact.GRUPOS} />}
                ></ListItemText>
              </ListItem>
            );
          });
        })}
        <div ref={bottomEl.ref}></div>
      </List>
    </Stack>
  );
};

export default StudentContacts;
